import React, { useEffect } from "react";
import { X } from "lucide-react";
import TrustPrivacyContent from "./TrustPrivacyContent";

// Lightweight full-screen, scrollable overlay. Controlled by local state so it
// works both logged-out (Auth) and logged-in (Settings) without any routing change.
export default function TrustPrivacySheet({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex justify-center"
      data-testid="trust-privacy-sheet"
      role="dialog"
      aria-modal="true"
      aria-label="Privacy and security"
    >
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-xl bg-[var(--bg)] shadow-2xl flex flex-col h-full settle-in">
        <header className="app-header-safe sticky top-0 z-10 bg-[var(--nav-bg)] backdrop-blur-md border-b border-[var(--line)]">
          <div className="h-[54px] px-5 flex items-center justify-between">
            <h2 className="font-serif-display text-[17px] text-[var(--ink)]">Privacy &amp; security</h2>
            <button
              type="button"
              onClick={onClose}
              data-testid="trust-privacy-close"
              aria-label="Close"
              className="h-9 w-9 -mr-2 rounded-full flex items-center justify-center text-[var(--ink3)] hover:bg-[var(--surface2)] transition-colors"
            >
              <X size={20} strokeWidth={2} />
            </button>
          </div>
        </header>
        <div className="flex-1 overflow-y-auto px-5 md:px-8 py-7 pb-12">
          <TrustPrivacyContent />
        </div>
      </div>
    </div>
  );
}
